
import {
  Chip,
  DialogContent,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { BranchType } from '../../../../interfaces/delivery-company/branches';
import { useState } from 'react';
import CreateBranchForm from '../create-branch-form/create-branch-form';
import { useSnackBar } from '../../../../contexts/snackbar';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { Star } from '@mui/icons-material';
import { BranchLetterBall } from '../../../common/branch-letter-ball/branch-letter-ball';

interface BranchesListingTableProps {
  branches: BranchType[];
  updateBranch: (b: BranchType) => void;
  isLoading: boolean;
}

function BranchesListingTable({
  branches,
  isLoading,
  updateBranch
}: BranchesListingTableProps) {
  const [editingBranch, setEditingBranch] = useState<BranchType>()
  const {showMessage} = useSnackBar();

  return (
    <TableContainer style={{ maxHeight: '80%' }}>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Table stickyHeader size='small'>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>Name</b>
              </TableCell>
              <TableCell align="center">
                <b>Area</b>
              </TableCell>
              <TableCell align="center">
                <b>Directions</b>
              </TableCell>
              <TableCell align="center">
                <b>Letter</b>
              </TableCell>
              <TableCell align="center">
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {branches.map((branch) => (
              <TableRow key={branch.id}>
                <TableCell align="center" style={{ cursor: 'pointer' }} onClick={()=>setEditingBranch(branch)}>
                    <b>{branch.name}</b>
                </TableCell>
                <TableCell align="center">{branch.area.name_en}</TableCell>
                <TableCell align="center">{branch.directions}</TableCell>
                <TableCell align="center">
                  <Box display="flex" justifyContent="center">
                    <BranchLetterBall letter={branch.letter} size={28} />
                  </Box>
                </TableCell>
                <TableCell align="center">{branch.is_default && <Chip size={"small"} color={"info"} icon={<Star />} label={"Primary"} />}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {
        editingBranch && <CustomDialog 
          open={true} 
          onClose={()=>setEditingBranch(undefined)}
          fullWidth
          maxWidth={"sm"}
        >

            <DialogContent>
              <CreateBranchForm 
                  defaultBranchId={editingBranch.id} 
                  successCallback={(b) => {
                    showMessage("Branch updated", "success")
                    updateBranch(b)
                    setEditingBranch(undefined);
                  }}
              />
            
          </DialogContent>

                 
          </CustomDialog>
      }
    </TableContainer>
  );
}

export default BranchesListingTable;
